<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.0002 2.23492L14.6571 13.7651H1.34326L8.0002 2.23492Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
</svg>
